<template>
  <!-- <div class="home m-flex m-row-center" :style="{backgroundImage:`url(${getWebConfig.login_image})`}"> -->
  <div class="home m-flex m-row-center" :style="{backgroundImage:`url(${getWebConfig.login_image})`}">
    <div class="login-wrap">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="登录"
          name="first"
        >
          <el-form
            class="m-form"
            :rules="login_rules"
            :model="login"
            ref="login"
            label-position="left"
          >
            <el-form-item prop="name">
              <el-input
                v-model="login.name"
                placeholder="请输入账号（注册时的手机号）"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="login.password"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item class="form-sub-wrap m-btn">
              <el-button @click="toLogin">登录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          label="注册"
          name="second"
        >
          <el-form
            class="m-form"
            :rules="register_rules"
            :model="register"
            ref="register"
            label-position="left"
          >
            <el-form-item prop="name">
              <el-input
                v-model="register.name"
                placeholder="请输入组织单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="contacts">
              <el-input
                v-model="register.contacts"
                placeholder="请输入参赛联系人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                v-model="register.phone"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item prop="province">
              <el-cascader
                class="m-select"
                v-model="province"
                :options="address"
                placeholder="请选择地区"
                @change="addressChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item prop="address">
              <el-input
                v-model="register.address"
                placeholder="请填写街道等具体地址"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="register.password"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item prop="old_password">
              <el-input
                v-model="register.old_password"
                placeholder="再次确认密码"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item class="form-sub-wrap m-btn">
              <el-button @click="toRegister">确认</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
        <div class="login-back text-center" @click="loginBack">
         返回首页
        </div>
    </div>
  </div>
</template>
  
  <script>
import { regionData, CodeToText } from "element-china-area-data";
import { Stock, chinaMap } from "@/store/mixin.js";
export default {
  name: "login",
  mixins: [Stock, chinaMap],
  data() {
    let validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (value != this.register.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    let validPhone = (rule, value, callback) => {
      if (!value.match(this.getVaidPhone)) {
        //console.log(this.getVaidPhone);
        callback(new Error("手机号格式不正确!"));
      } else {
        callback();
      }
    };
    let validAccount = (rule, value, callback) => {
      if (!value.match(this.getVaidPhone)) {
        //console.log(this.getVaidPhone);
        callback(new Error("登录账号格式不正确!"));
      } else {
        callback();
      }
    };
    return {
      isEvent:true,
      activeName: "first", //tab选中值first second
      address: regionData, //省市 联动
      province: null, //选中的省市区地址
      register: {
        name: "", //机构名
        contacts: "", //联系人姓名
        phone: "", //联系电话
        province: "", //省份
        city: "", //城市
        area: "", //市区
        address: "", //详细地址
        password: "", //密码
        old_password: "", //确认密码
      },
      login: {
        name: "",
        password: "",
      },
      login_rules: {
        name: [
          { required: true, message: "请输入登录账号(注册时的手机号)", trigger: "blur" },
          { validator: validAccount, trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }], //密码
      }, //登录验证
      register_rules: {
        name: [
          { required: true, message: "请输入组织单位名称", trigger: "blur" },
        ], //机构名
        contacts: [
          { required: true, message: "请输入参赛联系人姓名", trigger: "blur" },
        ], //联系人姓名
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: validPhone, trigger: "blur" },
        ], //联系电话
        province: [{ required: true, message: "请选择地区", trigger: "blur" }], //省份
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ], //详细地址
        password: [{ required: true, message: "请输入密码", trigger: "blur" }], //密码
        old_password: [{ validator: validatePass, trigger: "blur" }],
      }, //注册验证
    };
  },
  methods: {
    // 登录
    async toLogin() {
      this.$refs["login"].validate(async (valid) => {
        if(valid){
          let res = await this.$api.login(this.login),
          msg_type='error'
          if (res.code == 1) {
            msg_type='success'
            // 将用户信息存入缓存
            this.$cache.setCache('user_info',res.data)
            this.$router.push("/StudyFinland");
          }
          this.$message({
              message:res.info,
              type: msg_type,
              customClass: "m-msg",
            })
        }else{
          return false;
        }
      });
    },
    // 注册
    async toRegister() {
      if(!this.isEvent)return this.$var.msg('请勿频繁点击')
      this.isEvent=false
      setTimeout(() => {
        this.isEvent=true
      }, 3000);
      this.$refs["register"].validate(async (valid) => {
        if (valid) {
          delete this.register.old_password;
          let res = await this.$api.register(this.register),
          msg_type='error'
          if (res.code == 1) {
            msg_type='success'
            // 将用户信息存入缓存
            this.$cache.setCache('user_info',res.data)
            this.$router.push("/StudyFinland");
          }
          this.$message({
              message:res.info,
              type: msg_type,
              customClass: "m-msg",
            })
        } else {
          return false;
        }
      });
    },
    // 省市区地址选择
    addressChange(value) {
      //value是省市区类似id 返回数组 [110000,110100,110101]
      if (value[1] != null && value[2] != null) {
        this.register.province = CodeToText[value[0]];
        this.register.city = CodeToText[value[1]];
        this.register.area = CodeToText[value[2]];
      } else {
        if (value[1] != null) {
          this.register.province = CodeToText[value[0]];
          this.register.city = CodeToText[value[1]];
        } else {
          if (CodeToText[value[0]] == "全部")
            this.register.province = CodeToText[value[0]];
        }
      }
    },
    // 返回首页
    loginBack(){
      this.$router.push(`/home`);
    }
  },
};
</script>
  
<style lang="scss" scoped>
.home {
  position: relative;
  height: 100vh;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  -webkit-background-position: center;
  -moz-background-position: center;
  -o-background-position: center;
  background-position: center;
  .login-wrap {
    width: 555px;
    padding: 20px 0;
    background: #fff;
    .login-back{
      padding:0 40px;
      cursor: pointer;
      color: #cdcccd ;
    }
    & ::v-deep {
      .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
      }
      .el-tabs__nav {
        padding: 0.5em 0;
        .el-tabs__item {
          font-size: 30px;
          color: #b7b8b7;
          &.is-active,
          &:hover {
            color: #000;
          }
        }
        .el-tabs__active-bar {
          background-color: #000;
        }
      }
      .el-tabs__content {
        max-height: 500px;
        overflow-y: auto;
      }
      .el-form {
        margin: 0 40px;
        .no-bg .el-form-item__content {
          background-color: transparent;
          border: none;
        }
        .el-form-item__content {
          display: flex;
          .el-select,
          .m-select {
            width: 100%;
          }
          .el-input__inner {
            background-color: #f4f4f4;
            border: 1px solid #dddddd;
            &::placeholder {
              color: #cdcccd;
            }
          }
        }
        .m-btn {
          .el-button--default {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
  